import React, { useState, useEffect, useRef, Fragment } from "react";

// Librerias de componentes
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { ConfirmDialog } from "primereact/confirmdialog";

import { getRoles } from "../../../../API/IT/Roles/RolesRequests"; 
import { changePermisos } from "../../../../API/IT/Permisos/PermisosRequests";

import Loader from "../../../../Components/Loader/Loader";
import { addUser, getUsuarios } from "../../../../API/IT/Users/UserRequests";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests"; 
import { toastShow } from "../../../../Services/ToastService";
import { useForm } from "../../../../Hooks/useForm";
import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import { getPermisos } from "../../../../API/IT/Users/UserRequests";
import { getPersonal } from "../../../../../API/RRHH/Personal/PersonalRequests"; 
import { getTypesCategoria } from "../../../../API/Global/Types/TypeRequest";
import { MultiSelect } from "primereact/multiselect";
import { getAreasAct } from "../../../../API/Global/Areas/AreasRequests";

export const UsuariosCrud = ({
  usuarios,
  showDialog,
  setShowDialog,
  getUsers,
  modo,
}) => {
  const [roles, setRoles] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [personal, setPersonal] = useState([]);

  const [loading, setLoading] = useState(false);
  const [usuariosExistentes, setUsuariosExistentes] = useState([]);
  const [userList, setUserList] = useState([{}]);

  const [usuarioDialog, setUsuarioDialog] = useState(false);
  const [types, setTypes] = useState([]);
  const [subTypes, setSubTypes] = useState([]);
  const [areas, setAreas] = useState([]);

  const toast = useRef(null);

  const initialValues = {
    Usuario: "",
    UserName: "",
    Email: "",
    Password: "",
    IdStatus: "",
    IdRol: "",
    IdPersonal: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getInfo = async () => {
    setLoading(true);

    const obtUsuarios = await getUsuarios();
    const r = await getRoles();
    const e = await getEstadosCategory("Users");
    const u = await getUsuarios();

    const personalTempo = await getPersonal()
    setPersonal(personalTempo)
    setUsuariosExistentes(u);
    setEstados(e);
    setRoles(r);
    setUserList(obtUsuarios);

    const typesTempo = await getTypesCategoria('ActivoFijo');
    setTypes(typesTempo);

    const subTypesTempo = await getTypesCategoria('SubTipoActivo');
    setSubTypes(subTypesTempo);

    const sec = await getAreasAct();
    setAreas(sec);

    const areasSeleccionadas = Array.isArray(usuarios?.IdsAreas) ? usuarios.IdsAreas : typeof usuarios?.IdsAreas === 'string' ? usuarios.IdsAreas.split(',') .map(id => parseInt(id)) .map(id => sec.find(area => area.IdArea === id)) .filter(Boolean) : [];

    const estadoInicial =
      modo === "Crear"
        ? e[0]
        : e.find((e) => e.IdStatus === usuarios?.IdStatus);

    setValues({
      ...usuarios,
      Estado: estadoInicial,
      Roles: r.find((t) => usuarios?.IdRol === t.IdRol),
      Personal: personalTempo.find((t) => usuarios?.IdPersonalInt === t.IdPersonal),
      Type: typesTempo.find((t) => usuarios?.IdTipoActivo === t.IdType),
      SubType: subTypesTempo.find((st) => usuarios?.IdSubTipoActivo === st.IdType),
      Areas: areasSeleccionadas
    });
    setLoading(false);
  };

  const onHide = () => {
    setUsuarioDialog(false);
    resetForm();
    setShowDialog(false);
  };

  const verificarInfo = (e) => {
    let error = {};
    if (!values.Usuario) {
      error.Usuario = true;
      error.error = true;
    }
    if (!values.UserName) {
      error.UserName = true;
      error.error = true;
    }
    if (!values.Password) {
      error.Password = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.Roles || !values.Roles.IdRol) {
      error.IdRol = true;
      error.error = true;
    }
    // if (!values.Personal || !values.Personal.IdPersonal) {
    //   error.IdPersonal = true;
    //   error.error = true;
    // }
    // if (!values.IdPersonal) {
    //   error.IdPersonal = true;
    //   error.error = true;
    // }
    // if (values.Email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.Email)) {
    //   error.Email = true;
    //   error.error = true;
    // }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarUsuario = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingUser = userList.find((pr) => pr.Usuario === values?.Usuario);
      const codigoExists = userList.find((pr) => pr.IdPersonal === values.Personal?.CodigoPersonal);
      if ((existingUser || codigoExists) && (modo === "Crear" || existingUser.IdUser !== values.IdUser)) {
        toastShow(toast, "error", "Error", "El usuario o código ya existe en la base de datos.");
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          Usuario: values.Usuario,
          // UserName: values.UserName.toLowerCase().replace(/\b\w+\b/g, (word) => {
          //   return word.length <= 3 ? word : word.charAt(0).toUpperCase() + word.slice(1);
          // }),
          UserName: values.UserName,
          Password: values.Password,
          Email: values.Email,
          IdStatus: estadoId,
          IdRol: values.Roles.IdRol,
          IdPersonal: values.Personal?.CodigoPersonal,
          IdPersonalInt: values.Personal?.IdPersonal,
          IdTipoActivo: values.Type?.IdType,
          IdSubTipoActivo: values.SubType?.IdType,
          IdsAreas: values?.Areas?.map(area => area.IdArea).join(',')
        };

        const respuesta = await addUser(a);
        
        if (respuesta[0]?.ESTADO === 1) {
          const userId = respuesta[0]?.IdUser; 
          const IdPermisoHome = '2'; 
          const currentPermissions = await getPermisos(userId);
          let newPermissions = currentPermissions[0]?.PermissionMenu ? currentPermissions[0]?.PermissionMenu.split(',') : [];

          if (!newPermissions.includes(IdPermisoHome)) {
            newPermissions.push(IdPermisoHome);
          }

          await changePermisos({
            PermissionMenu: newPermissions.sort().toString(),
            IdUser: userId,
          });
  
          setLoading(true);
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          getUsers();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
        }
      }
    }
  };

  // Footer del Modal Editar
  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarUsuario();
          } else {
            agregarUsuario();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getInfo();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Nuevo Usuario" : "Editar Usuario ";

  return (
    <div>
      <ConfirmDialog />
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: "900px", minHeight: "400px" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <Toast ref={toast} />
          <h2>{dialogTitle}</h2>
          <div className="d-flex align-items-center flex-wrap">
            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Usuario"
                    value={values.Usuario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    autoFocus
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Usuario ? "p-invalid" : ""}
                  />
                  <label htmlFor="Usuario">Usuario</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="UserName"
                    value={values.UserName}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.UserName ? "p-invalid" : ""}
                  />
                  <label htmlFor="UserName">Nombre</label>
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Email"
                    value={values.Email}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Email ? "p-invalid" : ""}
                  />
                  <label htmlFor="Email">Correo</label>
                  {error.Email && (
                    <small className="p-error">
                      Correo electrónico iválido. E.g. example@email.com
                    </small>
                  )}
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <Password
                    id="Password"
                    name="Password"
                    value={values.Password}
                    onChange={handleInputChange}
                    toggleMask
                    autoComplete="off"
                    feedback={false}
                    style={{ width: "100%" }}
                    className={error.Password ? "p-invalid" : ""}
                  />
                  <label htmlFor="Password">Contraseña</label>
                </span>
              </div>
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Roles"}
                    value={values.Roles}
                    items={roles}
                    field={"Rol"}
                    label={"Rol"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdRol ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Personal"}
                    value={values.Personal}
                    items={personal}
                    field={"NombreConcatenado"}
                    label={"Codigo Personal"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdPersonal ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Type"}
                    value={values.Type}
                    items={types}
                    field={"Type"}
                    label={"Tipo Activo"}
                    handleInputChange={handleInputChange}
                    className={error.IdType ? "p-invalid" : ""}
                  />
                </span>
              </div>

              {/*Sub Tipo Activo */}
              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"SubType"}
                    value={values.SubType}
                    items={subTypes}
                    field={"Type"}
                    label={"Sub Tipo Activo"}
                    handleInputChange={handleInputChange}
                  />
                </span>
              </div>

              <div className="field col-4 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-8">
                <span className="p-float-label">
                  <MultiSelect
                    options={areas}
                    optionLabel={'Area'}
                    onChange={handleInputChange}
                    value={values?.Areas}
                    id="Areas"
                    name="Areas"
                    style={{ width: "100%" }}
                    filter
                    display="chip"
                    placeholder="Areas"
                  />
                  <label>Areas</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default UsuariosCrud;
